import { RootState } from "@Store";
import { IOrgUserUpdateRequest } from "./types";

export const selectUserUpdateRequests = (
  state: RootState
): IOrgUserUpdateRequest[] => state.userUpdateRequests.list;

/** @deprecated Use selectUserUpdateRequests */
export const selectPendingUserUpdateRequests = selectUserUpdateRequests;

export const selectHasPendingRequest = (state: RootState): boolean =>
  state.userUpdateRequests.hasPendingRequest;

export const selectUserUpdateRequestsLoading = (state: RootState): boolean =>
  state.userUpdateRequests.isLoading;

export const selectUserUpdateRequestActionInFlight = (
  state: RootState
): number | null => state.userUpdateRequests.actionInFlight;
